export function redirectToURL(url) {
    if (window && window.location) {
        window.location = url;
    }
}
